const minLength = 12;

const hasUppercase = /[A-Z]/;
const hasLowercase = /[a-z]/;
const hasNumber = /[0-9]/;
const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/;
const hasSpaces = /\s/;

type ValidatePasswordResult = [valid: boolean, messages: string[]]

export function validatePassword(password: string, passwordVerification: string): ValidatePasswordResult {
    const messages: string[] = []

    if (password.length < minLength) {
        messages.push("Password must be at least 12 characters long.")
    }
    if (password !== passwordVerification) {
        messages.push("Passwords do not match.")
    }
    if (!hasUppercase.test(password)) {
        messages.push("Password must contain at least one uppercase letter.")
    }
    if (!hasLowercase.test(password)) {
        messages.push("Password must contain at least one lowercase letter.")
    }
    if (!hasNumber.test(password)) {
        messages.push("Password must contain at least one number.")
    }
    if (!hasSpecialChar.test(password)) {
        messages.push("Password must contain at least one special character.")
    }
    if (hasSpaces.test(password)) {
        messages.push("Password cannot contain spaces.")
    }

    return [messages.length === 0, messages]
}
